import React from 'react';

export default class FreshChatWidget extends React.Component {

	constructor(props) {
		super(props);
		this.supportConfig = props.tenantConfig.support;
		this.user = props.session && props.session.user;
	}

	// This component has no state!
	shouldComponentUpdate() {
		return false;
	}

	componentDidMount() {
		let self = this;

		if (!(this.supportConfig && this.supportConfig.freshChat && this.supportConfig.freshChat.enabled)) {
			return;
		}

		if (window.addEventListener) {
			window.addEventListener('load', function () {
				self.enableFreshChatIfRequired();
			}, false);
		}
		else if (window.attachEvent) {
			window.attachEvent('onload', function () {
				self.enableFreshChatIfRequired();
			});
		}
	}

	componentWillUnmount() {
		if (window.fcWidget) {
			window.fcWidget.destroy();
		}
	}

	enableFreshChatIfRequired() {
		// Skip mobile, good enough detection
		if (window.devicePixelRatio && window.devicePixelRatio > 1 && window.screen && window.screen.width < 576) {
			return false;
		}

		if (window.fcWidget) {
			return;
		}

		const chatConfig = {
			token: this.supportConfig.freshChat.token,
			host: 'https://wchat.freshchat.com'
		};

		if (this.user) {
			chatConfig.externalId = '' + this.user.id;
			chatConfig.firstName = (this.user.firstName && this.user.firstName.trim()) || 'Guest';
			chatConfig.lastName = this.user.lastName || '';
			chatConfig.email = this.user.email;
		}

		const initFreshChat = function() {
			window.fcWidget.init(chatConfig);
		};

		setTimeout(function () {
			let script = document.createElement('script');
			script.id = 'freshchat-js-sdk';
			script.async = true;
			script.src = 'https://wchat.freshchat.com/js/widget.js';
			script.onload = initFreshChat;

			document.body.appendChild(script);
		}, 48);
	}

	render() {
		return null;
	}
}
